interface QuantityAdjustProps {
  quantity: number;
  increment: () => void;
  decrement: () => void;
}

export function QuantityAdjust({
  quantity,
  increment,
  decrement,
}: QuantityAdjustProps) {
  return (
    <>
      <label className="sr-only">Quantity, {quantity}</label>
      <div className="grid grid-cols-[45px_1fr_45px] border border-black h-[45px]">
        <button
          type="button"
          onClick={decrement}
          aria-label="Decrease quantity"
          className="py-1.5 px-3 flex justify-center items-center transition text-primary/40 hover:text-primary disabled:pointer-events-all disabled:cursor-wait"
        >
          &#8722;
        </button>
        <span className="border-x px-5 py-1.5 border-solid border-black flex justify-center items-center text-center text-primary/90">
          {quantity}
        </span>
        <button
          type="button"
          onClick={increment}
          aria-label="Increase quantity"
          className="py-1.5 px-3 flex justify-center items-center transition text-primary/40 hover:text-primary disabled:pointer-events-all disabled:cursor-wait"
        >
          &#43;
        </button>
      </div>
    </>
  );
}
